export default "__VITE_ASSET__DONzSS8F__"